import { styled } from '@mui/material/styles'
import { Grid } from '@mui/material'

export const GridContainer = styled(Grid)`
  display: flex;
  font-size: 14px;
  width: 100%;
`
